var waitFor = require("../utils/waitFor");

waitFor("#contacts-table", function () {
  var dt = require("datatables.net")(window, jQuery),
    dt_fixedheader = require("datatables.net-fixedheader")(window, jQuery),
    dt_fixedcolumns = require("datatables.net-fixedcolumns")(window, jQuery),
    dtUtils = require("../utils/dtUtils");

  // Results table
  var colData = [
    {
      prop: "partnumber",
      title: "Part Number",
      className: "col-emphasize",
      width: "200px",
    },
    {
      prop: "rohs",
      title: "RoHS 5/6 (< 4% lead)",
      width: "100px",
    },
    {
      prop: "size",
      title: "Size",
      width: "100px",
    },
    {
      prop: "type",
      title: "Type",
      width: "120px",
    },
    {
      prop: "termination",
      title: "Termination",
      width: "130px",
    },
    {
      prop: "gender",
      title: "Gender",
      width: "200px",
    },
    {
      prop: "female_contact_style",
      title: "Female Contact Style",
      width: "200px",
    },
    {
      prop: "current_rating",
      title: "Current Rating (A)",
      width: "200px",
    },
    {
      prop: "initial_contact_resistance",
      title: "Initial Contact Resistance (mΩ)",
      width: "200px",
    },
    {
      prop: "wire_size",
      title: "Wire Size (AWG)",
      width: "200px",
    },
    {
      prop: "overall_length",
      title: "Overall Length",
      width: "200px",
    },
    {
      prop: "barrel_depth",
      title: "Barrel Depth",
      width: "200px",
    },
    {
      prop: "barrel_internal_diameter",
      title: "Barrel Internal Diameter",
      width: "200px",
    },
    {
      prop: "material",
      title: "Material",
      width: "200px",
    },
    {
      prop: "plating",
      title: "Plating",
      width: "200px",
    },
    {
      prop: "notes",
      title: "Notes",
      width: "200px",
    },
  ];

  var dtOpts = {
    data: dtUtils.formatResultsData(window.contactsData, colData),
    columns: dtUtils.buildDataTablesColumns(colData),
    fixedHeader: true,
    fixedColumns: true,
    searching: true,
    lengthChange: false,
    info: false,
    scrollX: true,
    autoWidth: false,
    language: {
      search: "Search Part Number:",
    },
    drawCallback: function () {
      $(".dataTables_scrollBody").scroll(alignFixedHeaderWithBody);
      $("#contacts-table_wrapper").addClass("table-mobile-unavailable-lg");
    },
  };

  function alignFixedHeaderWithBody() {
    var scrollLeft = $(".dataTables_scrollBody").scrollLeft();
    $(".fixedHeader-floating").css("left", -scrollLeft); //fix the thead relative to the body scrolling
    $(".fixedHeader-floating th:nth-child(1)").css({
      left: scrollLeft,
      // 'z-index': 10
    }); //fix the first cell of the header
  }

  if (window.contactsData.length > 10)
    dtOpts.dom =
      'f<"dataTables-top-pagination"p>t<"dataTables-bottom-pagination"p>';

  var dtInstance = $("#contacts-table").DataTable(dtOpts);

  // redraw when siwtching to the tab
  $('[role="tablist"] a[href="#contacts"]').click(function () {
    setTimeout(function () {
      dtInstance.draw();
    }, 50);

    (function tableAlignmentInterval() {
      alignFixedHeaderWithBody();
      setTimeout(tableAlignmentInterval, 400);
    })();
  });

  $("#contacts-table").on("page.dt", function () {
    $("html, body").animate(
      {
        scrollTop: $("#contacts").offset().top - 40,
      },
      300
    );
  });
});
